import { adminHttpClient } from '../../../commons/adminHttpClient'

export enum RenewalStatus {
  Automatic,
  Semi,
  Manual,
}

export type PlanPeriodRenewalActivity = {
  planPeriodId: string
  status: number
  productTasksInfo: string[]
}

const getPlanPeriodRenewalActivity = (): Promise<PlanPeriodRenewalActivity> => {
  return adminHttpClient.get(`Benefit/BenefitRenewal/PlanPeriodRenewalActivity`)
}

export default getPlanPeriodRenewalActivity
